import legalTender from "./legalTender.js";
import virtualCoin from "./virtualCoin.js";
import otcTransactionDetails from "./otcTransactionDetails.js";

export default {
  legalTender,
  virtualCoin,
  otcTransactionDetails,
};
